module.exports = __webpack_public_path__ + "815f45fa20322e769793485fb4d4ee5e.png";